<template>
  <div class="top-bar-link">
    <a :href="anchor" :class="statusClass" @click="updateActiveLink">{{ $resourceString[`${title}`] }}</a>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    anchor: String,
  },
  data() {
    return {
      statusClass: "pdp-side-menu-link-inactive",
      anchorTarget: null,
      anchorScrollOffset: 400, 
    };
  },
  mounted() {
    window.addEventListener("scroll", this.updateStatusClass);
    this.updateStatusClass();
    this.setFirstLinkActive();
  },
  methods: {
    updateActiveLink() {
      // Remove the "pdp-side-menu-link-active" class from all links
      const links = document.querySelectorAll(".top-bar-link a");
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("pdp-side-menu-link-active");
        links[i].classList.add("pdp-side-menu-link-inactive");
      }
      
      // Add the "pdp-side-menu-link-active" class to the clicked link
      const clickedLink = event.target;
      clickedLink.classList.add("pdp-side-menu-link-active");
      clickedLink.classList.remove("pdp-side-menu-link-inactive");
    },
    setFirstLinkActive() {
      const firstMenuLink = document.querySelectorAll(".top-bar-link a")[0];
      firstMenuLink.classList.remove("pdp-side-menu-link-inactive");
      firstMenuLink.classList.add("pdp-side-menu-link-active");
    },
    updateStatusClass() {
    // Status class is 'active' when the anchor target element's bounding rectangle intersects the top of the viewport
      if (!this.anchorTarget) {
        this.anchorTarget = document.querySelector(this.anchor);
      }

      if (this.anchorTarget) {
        const anchorTargetBounds = this.anchorTarget.getBoundingClientRect();
        const isActive =
          anchorTargetBounds.top <= this.anchorScrollOffset &&
          anchorTargetBounds.bottom > this.anchorScrollOffset;
        this.statusClass =
          "pdp-side-menu-link-" + (isActive ? "active" : "inactive");
      }
    },
  }
};
</script>

<style></style>
